import { render, staticRenderFns } from "./CloseBookDateList.vue?vue&type=template&id=61cd9c27&"
import script from "./CloseBookDateList.vue?vue&type=script&lang=js&"
export * from "./CloseBookDateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports